export default "__VITE_ASSET__DZHf2jsN__"